<template>
  <div class="input-search-group">
  <v-sheet class="mx-auto" width="400">
    <v-text-field
      clearable
      v-model="searchData"
      :placeholder="placeholder"></v-text-field>
    <v-menu
      v-model="searchMenu"
      transition="slide-y-transition"
      location="right top"
    >
      <template v-slot:activator="{ props }">
        <v-btn v-bind="props" class="btn-search">
          <span class="hide-txt">{{t('message.search')}}</span>
        </v-btn>
      </template>
      <v-list class="srch-menu-list">
        <v-list-item
          v-for="(item, i) in searchList"
          :key="i"
        >
          <v-list-item-title>
            <button type="button" @click="onClickItem(item)">
              {{ `${item.memberName||t('message.noInfo')}(${item.memberId})` }}
            </button>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-sheet>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n';
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import utils from "@/common/Utils";
const { t } = useI18n();

const props = defineProps(['placeholder'])
const emit = defineEmits(['confirm'])

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//ref
const snackbar = ref(false)
const snackText = ref('')
const searchMenu = ref(false)
const searchData = ref('')
const searchList = ref([])

//function
const onClickItem=(item)=>{
  emit('confirm', item)
}

//watch
watch(searchMenu, (val) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const leadershipData = storeRef.leadershipInfo.value as any
  const isReportAdmin = _.some((storeRef.leadershipInfo.value as any).reportTargets, {idx:user.memberIdx})
  if (val) {
    if ((user.roles === 'USER') && !isReportAdmin) {
      snackText.value = '검색 권한이 없습니다.'
      snackbar.value = true
      return
    }

    const filterList:any = _.filter((storeRef.leadershipInfo.value as any).leadershipTargets, (item) => {
      return item.memberId.includes(searchData.value) || item.memberName.toLowerCase().includes(searchData.value.toLowerCase())
    })
    searchList.value = filterList
  }
})
</script>
<style lang="scss"> //scoped
.srch-menu-list{
  margin-left: 1rem;
}
</style>
